"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVENTORY_FLOWS = void 0;

var _addition = require("./addition");

var _transfer = require("./transfer");

var _removal = require("./removal");

var INVENTORY_FLOWS = {
  ADDITION: _addition.ADDITION,
  TRANSFER: _transfer.TRANSFER,
  REMOVAL: _removal.REMOVAL
};
exports.INVENTORY_FLOWS = INVENTORY_FLOWS;